import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const ProofSection = ({ data, onCtaClick }) => {
  return (
    <section className="px-5 sm:px-6 py-14 md:py-20 bg-white">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-900 text-center mb-3">
          {data.title}
        </h2>
        
        {/* Caption Above Images */}
        <p className="text-center text-gray-600 mb-8 sm:mb-10 text-sm sm:text-base leading-relaxed">
          Real communal areas maintained through regular scheduled cleaning.
        </p>
        
        {/* Before/After Images - load eagerly for instant display */}
        <div className="space-y-5 sm:space-y-6 mb-4">
          {data.images.map((image, index) => (
            <div key={index} className="overflow-hidden rounded-2xl shadow-[0_1px_3px_rgba(0,0,0,0.06),0_1px_2px_rgba(0,0,0,0.04)] border border-gray-100/80">
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-auto object-contain"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          ))}
        </div>
        
        {/* Disclaimer Text */}
        <p className="text-center text-gray-400 text-xs mb-10 leading-relaxed">
          Examples show ongoing maintenance standards — not one-off presentation cleans.
        </p>
        
        {/* CTA */}
        <div className="text-center">
          <Button
            onClick={onCtaClick}
            size="lg"
            data-testid="proof-section-cta-btn"
            className="bg-[#00c853] hover:bg-[#00a844] text-white px-6 sm:px-8 py-4 text-base sm:text-lg font-medium rounded-xl transition-all duration-200 h-auto min-h-[48px] sm:min-h-[56px] shadow-[0_2px_8px_rgba(0,200,83,0.25)] hover:shadow-[0_4px_12px_rgba(0,200,83,0.35)] hover:-translate-y-0.5 active:translate-y-0"
          >
            Get a Free Site Assessment
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProofSection;
